import { Stack } from "@vapor/react-material";
import { Search } from "./SearchBar";
import { useState } from "react";
import Button from "@vapor/react-material/Button";
import { useTranslation } from "@onefront/react-sdk";
import DocumentFilters from "./DocumentFilters";
import { useNavigate } from "react-router-dom";
import { UploadSmartComponent } from "@onefront/documents-smart-components";
import { useClientInformationStore } from "../../../store/useClientInformationStore";
import { checkIdExists } from "../../../../utils/checkIdExists";
import { config } from "../../../../config";
import { useAuth } from "@onefront/react-sdk";

const LeftPannel = ({
  setSearchValue,
  handleFilterChange,
  documentFilterOption,
}) => {
  const [checkIfUploaded, setCheckIfUploaded] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation("DOCS");

  const {
    selectedTenant: currentCompany,
    selectedWorkspace: ws,
    workspaceId,
    setWorkspaceId,
    tenantId,
  } = useClientInformationStore();
  const [allowAssistant, setAllowAssistant] = useState(
    checkIdExists(config.allowAssistant, tenantId)
  );
  const [userCanUpload, setUserCanUpload] = useState(false);
  const subtitle = ws
    ? `${
        [...ws.companies, ...ws.accountants].find((x) => x.id === workspaceId)
          ?.description ?? ""
      }`
    : "";
  const auth = useAuth().tokenData;
  const user = {
    id: auth?.client_id,
    email: auth?.email,
    firstName: auth?.given_name,
    lastName: auth?.family_name,
  };
  const isAccountant = ws?.itemType === "ACCOUNTANT";
  const company = ws?.companies?.at(0);
  const accountant = ws?.accountants?.at(0);
  const userAccount = isAccountant ? accountant : company;
  const account = {
    id: userAccount?.id,
    name: userAccount?.description,
  };

  return (
    <Stack>
      <UploadSmartComponent
        loggedItemId={currentCompany?.itemId}
        setCheckIfUploaded={setCheckIfUploaded}
        isAccountant={ws?.itemType !== "COMPANY" ? true : false}
        subtitle={subtitle}
        workspaceId={workspaceId}
      />
      <Search setSearchValue={setSearchValue} width="stretch" />
      <p />
      <DocumentFilters
        handleFilterChange={handleFilterChange}
        documentFilterOption={documentFilterOption}
      />
    </Stack>
  );
};

export default LeftPannel;
